import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const SupplierStatusField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`pos.supplier_status.${record[source]}`) } </span>
      );
};

SupplierStatusField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default SupplierStatusField;
